'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'deer';
var width = 512;
var height = 512;
var aliases = [129420];
var unicode = 'f78e';
var svgPathData = 'M256 16l0-16L224 0l0 16 0 24c0 30.9 25.1 56 56 56l8 0 8 0 23.2 0-40 26.7-13.3 8.9 17.8 26.6 13.3-8.9 13.8-9.2-10 35.9L120 176l-16 0-8 0c-53 0-96 43-96 96l0 48 0 16 32 0 0-16 0-9.4 16 16 0 22.8L32.8 394.9 31.1 400l1.7 5.1 32 96L68.5 512 80 512l80 0 22.2 0-7-21.1L147 406.5l37.8-25.2 8.6-5.7-1.7-10.2-1.9-11.6 17.3 11.5 4 2.7 4.8 0 56 0 0 128 0 16 16 0 80 0 16 0 0-16 0-185c0-3.1 .5-6.2 1.4-9.2L403.9 240l92.1 0 16 0 0-16 0-56 0-6.6-4.7-4.7L440.8 90.2C459.3 81.1 472 62 472 40l0-24 0-16L440 0l0 16 0 24c0 13.3-10.7 24-24 24l-1.4 0L408 64l-61.4 0c3.5-7.3 5.4-15.4 5.4-24l0-24 0-16L320 0l0 16 0 24c0 13.3-10.7 24-24 24l-8 0-8 0c-13.3 0-24-10.7-24-24l0-24zM401.4 96L480 174.6l0 33.4-88 0-11.9 0-3.4 11.4-22 73.3c-1.8 6-2.7 12.2-2.7 18.4l0 169-48 0 0-128 0-16-16 0-67.2 0-44-29.3-24.7 15.9 6.3 37.8-39.4 26.3L109 393.5l3.9 11.6 25 74.9-46.3 0L64.9 400l14.3-42.9 .8-2.5 0-2.6 0-32 0-6.6-4.7-4.7L48 281.4 48 264c0-30.9 25.1-56 56-56l16 0 192.9 0 12.2 0 3.3-11.7L356.2 96l45.2 0zM416 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDeer = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;